import React from 'react';
import ErrorMessage from './ErrorMessage';
import { PanelHeader } from 'js/components';
import { Card, CardBody } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';

function DashboardPageErrorBoundaryUI(props) {
  return (
    <div>
      <PanelHeader size="flex"></PanelHeader>
      <div className="content">
        <Card>
          <CardBody>
            <ErrorMessage {...props} />
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

function DashboardPageErrorBoundary({ children }) {
  return (
    <ErrorBoundary fallbackUI={DashboardPageErrorBoundaryUI}>
      {children}
    </ErrorBoundary>
  );
}

export default DashboardPageErrorBoundary;
